import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f84fb12")

_pushScopeId("data-v-3f84fb12")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "dialog-body" }
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "field start-date" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "开始日期", -1)
const _hoisted_8 = { class: "field end-date" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "结束日期", -1)
const _hoisted_10 = { class: "table-wrap" }
const _hoisted_11 = { class: "table" }
const _hoisted_12 = /*#__PURE__*/_createVNode("th", null, "时间", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("th", null, "笔数", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("th", null, "总投", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("th", null, "总赢", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("th", null, "洗码费投注", -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createVNode("th", null, "小结", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("th", null, "详细", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  colspan: 7,
  class: "no-record"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, "游戏记录", -1)
const _hoisted_26 = { class: "dialog-body" }
const _hoisted_27 = { class: "form" }
const _hoisted_28 = { class: "field start-date" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", null, "开始日期", -1)
const _hoisted_30 = { class: "field end-date" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, "结束日期", -1)
const _hoisted_32 = { class: "table-wrap" }
const _hoisted_33 = { class: "table" }
const _hoisted_34 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "游戏编号"),
    /*#__PURE__*/_createVNode("th", null, "靴-局"),
    /*#__PURE__*/_createVNode("th", null, "桌台"),
    /*#__PURE__*/_createVNode("th", null, "游戏结果"),
    /*#__PURE__*/_createVNode("th", null, "投注类型"),
    /*#__PURE__*/_createVNode("th", null, "投注金额"),
    /*#__PURE__*/_createVNode("th", null, "输赢"),
    /*#__PURE__*/_createVNode("th", null, "投注时间")
  ])
], -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createVNode("td", {
  colspan: 7,
  class: "no-record"
}, " 没有查询到记录 ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_calendar_picker = _resolveComponent("calendar-picker")

  return (_openBlock(), _createBlock("div", {
    class: ["history-view-root", { mobile: _ctx.isMobile }]
  }, [
    _createVNode("div", _hoisted_1, [
      (!_ctx.showDetails)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", null, _toDisplayString(_ctx.iN('setting.betrecord')), 1),
              _createVNode("span", {
                class: "icon-close",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.OnClickClose()))
              })
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_calendar_picker, {
                    class: "calendar-picker",
                    value: _ctx.startDate,
                    placeHolder: 
                                    _ctx.isMobile ? '开始日期' : 'YYYY/MM/DD'
                                ,
                    onOnChange: _ctx.OnStartDateChange
                  }, null, 8, ["value", "placeHolder", "onOnChange"])
                ]),
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_calendar_picker, {
                    class: "calendar-picker",
                    value: _ctx.endDate,
                    placeHolder: 
                                    _ctx.isMobile ? '结束日期' : 'YYYY/MM/DD'
                                ,
                    onOnChange: _ctx.OnEndDateChange
                  }, null, 8, ["value", "placeHolder", "onOnChange"])
                ]),
                _createVNode("div", {
                  class: "btn-search",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.OnClickViewBetHistory && _ctx.OnClickViewBetHistory(...args)))
                }, _toDisplayString(_ctx.iN('common.search')), 1)
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("table", _hoisted_11, [
                  _createVNode("thead", null, [
                    _createVNode("tr", null, [
                      _hoisted_12,
                      _hoisted_13,
                      _hoisted_14,
                      _hoisted_15,
                      _hoisted_16,
                      (_ctx.showCommission)
                        ? (_openBlock(), _createBlock("th", _hoisted_17, "洗码费"))
                        : _createCommentVNode("", true),
                      _hoisted_18,
                      _hoisted_19
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_ctx.betRecord.length === 0)
                      ? (_openBlock(), _createBlock("tr", _hoisted_20, [
                          _createVNode("td", _hoisted_21, _toDisplayString(_ctx.iN('common.norecordfound')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.betRecord, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("td", null, _toDisplayString(item.day), 1),
                        _createVNode("td", null, _toDisplayString(item.id), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.roundFixed2(item.betAmount)), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.roundFixed2(item.winResult)), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.roundFixed2(item.betValidAmount)), 1),
                        (_ctx.showCommission)
                          ? (_openBlock(), _createBlock("td", _hoisted_22, _toDisplayString(item.expand.commissionAmount), 1))
                          : _createCommentVNode("", true),
                        _createVNode("td", null, _toDisplayString(_ctx.roundFixed2(item.expand.totalAmount)), 1),
                        _createVNode("td", null, [
                          _createVNode("span", {
                            class: "btn",
                            onClick: ($event: any) => (_ctx.OnClickLogsItem(item.day))
                          }, "详细", 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode("span", {
                class: "icon-close",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDetails = false))
              })
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode(_component_calendar_picker, {
                    class: "calendar-picker",
                    value: _ctx.startDate,
                    enabled: false
                  }, null, 8, ["value"])
                ]),
                _createVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_calendar_picker, {
                    class: "calendar-picker",
                    value: _ctx.endDate,
                    enabled: false
                  }, null, 8, ["value"])
                ])
              ]),
              _createVNode("div", _hoisted_32, [
                _createVNode("table", _hoisted_33, [
                  _hoisted_34,
                  _createVNode("tbody", null, [
                    (_ctx.betRecordInfo.length === 0)
                      ? (_openBlock(), _createBlock("tr", _hoisted_35, [
                          _hoisted_36
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.betRecordInfo, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("td", null, _toDisplayString(item.gameNo), 1),
                        _createVNode("td", null, _toDisplayString(item.shoeNo + '/' + item.juNo), 1),
                        _createVNode("td", null, _toDisplayString(item.gameTypeName) + " " + _toDisplayString(item.tableNo), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.getGameResult(item)), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.handleBetTypeData(item)), 1),
                        _createVNode("td", null, _toDisplayString(Math.floor(item.betAmount)), 1),
                        _createVNode("td", null, _toDisplayString(Math.floor(item.winResult)), 1),
                        _createVNode("td", null, _toDisplayString(item.betTime), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
    ])
  ], 2))
})